export default "__VITE_ASSET__CDhmbuae__"